// The informational pages' slugs and paths, apart from the page itself so the
// router can list them without downloading their text (pages/StaticPage.jsx).
export const STATIC_PAGES = {
  about: "/about", faq: "/faq", refund: "/refund-policy",
  terms: "/terms", privacy: "/privacy", cookies: "/cookies",
};
